module.exports = __webpack_public_path__ + "img/flag-en.84bd091e.svg";